import React from 'react'
import PageHeader from '../components/PageHeader'
import pdf1 from "../assets/TimeTableArts.pdf"
import pdf2 from "../assets/TimeTableCommerceFaculty.pdf"
import pdf3 from "../assets/TimeTableScienceFaculty.pdf"

function Timetable() {
  const tbodyData = [
    {
      id: 1,
      title: "Arts Faculty",
      file: pdf1
    },
    {
      id: 2,
      title: "Commerce Faculty",
      file: pdf2
    },
    {
      id: 2,
      title: "Science Faculty",
      file: pdf3
    }]
  return (
    <div>
      <PageHeader title="Timetable" />

      <div className='contentarea' style={{ background: "white" }}>

        <div className='sub-contentarea' style={{ boxShadow: "none", padding: "none" }}>
          <div>

            <table>
              <thead>
                <tr>
                  <th>SR NO.</th>
                  <th>Subject</th>
                  <th>Link</th>
                </tr>
              </thead>
              <tbody style={{ textTransform: "uppercase" }}>

                {
                  tbodyData.map((data, index) => (
                    <tr key={data.id}>
                      <td>{index + 1}</td>
                      <td>{data.title}</td>
                      <td>
                        <a target="_blank" href={data.file}>Get Document</a>
                      </td>
                    </tr>
                  ))
                }



              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Timetable
